var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("position: relative; width: " + (_vm.size + 5) + "px; height: " + (_vm.size + 5) + "px"))},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"spin-icon-load",attrs:{"type":"ios-loading","size":_vm.size}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }